'use client';

import { Box, Container } from '@doist/marketist';
import cn from 'clsx';
import { MainPageHeader } from 'components/main-page-header/main-page-header';
import { useSearchParams } from 'next/navigation';
import { Search } from '../search/search';
import css from './page-header.module.css';
import type { IntegrationsHomeData } from 'app/[locale]/integrations/types';
type HeaderProps = IntegrationsHomeData & {
  className?: string;
  searchString?: string;
};
function PageHeader({
  fields: {
    header = '',
    subheader = ''
  },
  className,
  searchString = ''
}: HeaderProps) {
  const searchParams = useSearchParams();
  return <Container className={cn(css.header, className)} width="sm" data-sentry-element="Container" data-sentry-component="PageHeader" data-sentry-source-file="page-header.tsx">
            <MainPageHeader title={header} subtitle={subheader} size="sm" data-sentry-element="MainPageHeader" data-sentry-source-file="page-header.tsx" />
            <Box className={css.search} data-sentry-element="Box" data-sentry-source-file="page-header.tsx">
                <Search searchString={searchString} onSearch={(searchString?: string) => {
        if (!searchParams) return;
        const params = new URLSearchParams();
        const url = '/integrations/category/all';
        const lang = searchParams.get('lang');
        if (lang && lang !== 'en') params.set('lang', lang);
        if (searchString) {
          params.set('search', searchString);
          window.location.href = `${url}?${params.toString()}`;
        }
        window.location.href = `${url}?${params.toString()}`;
      }} showLabel={false} data-sentry-element="Search" data-sentry-source-file="page-header.tsx" />
            </Box>
        </Container>;
}
export { PageHeader };